/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{d as r,r as e}from"./ProjectionTransformation.js";class t extends r{getOperatorType(){return 4}execute(r,t,o,s){return!e(r,t,o,4,s)}}export{t as O};
